import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ScrollProgress } from '@/components/ScrollProgress';
import { StickyNav } from '@/components/StickyNav';
import { Hero } from '@/components/Hero';
import { InsightHook } from '@/components/InsightHook';
import { AgingExplorer } from '@/components/AgingExplorer';
import { AuthorityQuote } from '@/components/AuthorityQuote';
import { Ecosystem } from '@/components/Ecosystem';
import { PreviewCard } from '@/components/PreviewCard';
import { DidYouKnow } from '@/components/DidYouKnow';
import { WaitlistSection } from '@/components/WaitlistSection';
import { CollaborationSection } from '@/components/CollaborationSection';
import { BioAgeTeaser } from '@/components/BioAgeTeaser';
import { FAQ } from '@/components/FAQ';
import { FinalCTA } from '@/components/FinalCTA';
import { LocationCard } from '@/components/LocationCard';
import { Footer } from '@/components/Footer';
import { FloatingContact } from '@/components/FloatingContact';
import { GoldDivider } from '@/components/GoldDivider';
import { SEOHead } from '@/components/SEOHead';
import { trackPageView } from '@/lib/analytics';

const SUPPORTED_LANGS = ['en', 'zh'];

export const LandingPage = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  const validLang = SUPPORTED_LANGS.includes(lang) ? lang : null;

  useEffect(() => {
    if (!validLang) return;
    if (i18n.language !== validLang) {
      i18n.changeLanguage(validLang);
    }
    document.documentElement.lang = validLang;
    trackPageView();
  }, [validLang, i18n]);

  if (!validLang) {
    return <Navigate to="/en" replace />;
  }

  return (
    <>
      <SEOHead lang={lang === 'zh' ? 'zh' : 'en'} />
      <ScrollProgress />
      <StickyNav />
      <FloatingContact />
      <Hero />
      <GoldDivider />
      <InsightHook />
      <GoldDivider />
      <AgingExplorer />
      <GoldDivider />
      <AuthorityQuote />
      <GoldDivider />
      <Ecosystem />
      <GoldDivider />
      <PreviewCard />
      <GoldDivider />
      <DidYouKnow />
      <GoldDivider />
      <WaitlistSection />
      <GoldDivider />
      <CollaborationSection />
      <GoldDivider />
      <BioAgeTeaser />
      <GoldDivider />
      <FAQ />
      <GoldDivider />
      <FinalCTA />
      <GoldDivider />
      <LocationCard />
      <Footer />
    </>
  );
};
